import React,{useState} from 'react'
import './EventCard.css'
import { Fade } from 'react-awesome-reveal'
import Modal from '../Modal/Modal'
// import { useNavigate, useParams } from "react-router-dom";


const EventCard = ({
    data,show
  }) => {
    

      
    const[openModal,setOpenModal]= useState(show);
    const modal =()=>{
      setOpenModal(true);
    }
  return (
    <>
    <Fade>
        <div className='event-card'>      
                    <img src={data.image} alt='img'className='icon'></img>
                    <div className='event-card-bot'>
                    <h3 className='event-card-name'>{data.name}</h3>
                    <p>{data.smallDesc}
                     <span style={{paddingRight: "0px", color: "red",marginTop:"0.4rem",display:"block"}}>{data.faqUpdate}</span></p>
                     <div className='card-bot-but'>
                      <div>
                    <span>{data.date}</span>
                    <span>{data.time}</span>
                    </div>
                    <button className='button-62' onClick={modal}>Details</button>
                    </div>
                   
                    </div>
                </div>
                </Fade>
                {
                  openModal && <Modal data={data}  closeModal={setOpenModal} /> 
                }
               
                </>
   
  )
}

export default EventCard